class HitAreaManager {
  constructor(iframeElToListenTo) {
    this.iframeElToListenTo = iframeElToListenTo;
    this.hitAreas = [];
  }

  setHitAreas(hitAreas) {
    const transformedHitAreas = hitAreas.map(this._transformToGlobal.bind(this));
    this.hitAreas = transformedHitAreas;
  }

  _transformToGlobal(hitArea) {
    const iframeRect = this.iframeElToListenTo.getBoundingClientRect();

    const transformedX = hitArea.rect.x + iframeRect.left;
    const transformedY = hitArea.rect.y + iframeRect.top;

    const transformedHitArea = {
      droppableId: hitArea.droppableId,
      rect: {
        x: transformedX,
        y: transformedY,
        w: hitArea.rect.w,
        h: hitArea.rect.h,
      },
      zIndex: hitArea.zIndex,
    };
    return transformedHitArea;
  }

  removeHitAreas() {
    this.hitAreas = [];
  }

  hitTest(point) {
    let highestZIndex = Infinity * -1;
    const allHits = [];
    for (const hitArea of this.hitAreas) {
      if (
        point.x >= hitArea.rect.x && point.x < (hitArea.rect.x + hitArea.rect.w) &&
        point.y >= hitArea.rect.y && point.y < (hitArea.rect.y + hitArea.rect.h)
      ) {
        allHits.push({
          id: hitArea.droppableId,
          zIndex: hitArea.zIndex,
        });

        if (highestZIndex < hitArea.zIndex) {
          highestZIndex = hitArea.zIndex;
        }
      }
    }

    const hitsWithHighestZIndex = allHits
      .filter(({ zIndex }) => typeof zIndex !== 'undefined' ? zIndex === highestZIndex : true)
      .map(({ id }) => id);
    const hits = new Set(hitsWithHighestZIndex);

    return hits;
  }

  destroy() {
    // No need to do anything, but could be used in the future.
  }

  static addTransparentDivs() {
    const iframes = document.querySelectorAll('iframe');

    for (const iframe of iframes) {
      const iframeRect = iframe.getBoundingClientRect();

      const transparentDiv = document.createElement('div');
      transparentDiv.classList.add('HitAreaManager-Overlay');
      transparentDiv.style.setProperty('position', 'fixed');
      transparentDiv.style.setProperty('left', `${iframeRect.left}px`);
      transparentDiv.style.setProperty('top', `${iframeRect.top}px`);
      transparentDiv.style.setProperty('width', `${iframeRect.width}px`);
      transparentDiv.style.setProperty('height', `${iframeRect.height}px`);

      document.body.appendChild(transparentDiv);
    }
  }

  static removeTransparentDivs() {
    const transparentDivs = document.querySelectorAll('div.HitAreaManager-Overlay');

    for (const transparentDiv of transparentDivs) {
      document.body.removeChild(transparentDiv);
    }
  }
}

export default HitAreaManager;
